import { toastConstants } from '../constants';

const { ENQUEUE_TOAST  } = toastConstants;

const initialState = {
	toast: null,
};

const reducer = (state = initialState, payload) => {
	const { type, toast } = payload;
	
	switch (type) {
		case ENQUEUE_TOAST:
			return {
				...state,
				toast,
			};
		default:
			return state;
	}
};

export default reducer;


// WEBPACK FOOTER //
// ./src/redux/reducers/toast.reducers.js